import { render, staticRenderFns } from "./TransitionContainer.vue?vue&type=template&id=50e4571a&scoped=true&"
import script from "./TransitionContainer.vue?vue&type=script&lang=js&"
export * from "./TransitionContainer.vue?vue&type=script&lang=js&"
import style0 from "./TransitionContainer.vue?vue&type=style&index=0&id=50e4571a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4571a",
  null
  
)

export default component.exports